// TODO: change response data once BE ready
export const LOGOUT_POST_SUCCESS_RESPONSE = {
  data: {},
  meta: null,
}
